module.exports = __webpack_public_path__ + "static/img/case4.a417ab43.jpg";